import script from "./ButtonsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ButtonsComponent.vue?vue&type=style&index=0&id=7a41c632&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a41c632"]])

export default __exports__